<template>
  <div ref="promptContainer" class="prompt-bar-container">
    <div class="content-container">
      <div class="icon">
        <slot name="icon"></slot>
      </div>
      <div class="text-container">
        <div class="text-title">
          <slot name="title"></slot>
        </div>
        <div class="text-description">
          <slot name="description"></slot>
        </div>
      </div>
    </div>
    <div v-if="$slots['button-container']" class="button-container">
      <slot name="button-container" />
    </div>
    <div v-if="showProgressBar" class="progress-bar"></div>
    <FriedIconButton
      v-if="closable"
      data-external="prompt-bar-close-button"
      class="close-button"
      @click="$emit('close')"
    >
      <FriedIcon class="close-icon" icon="close" />
    </FriedIconButton>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    showProgressBar: {
      type: Boolean,
      default: true,
    },
    closable: {
      type: Boolean,
    },
  },
  emits: ['close'],
});
</script>

<style lang="scss" scoped>
@import '@getaccept/lib-ui';

$mobile-height: 8.5625rem;
$progress-text-blue: #194c71;
$background-blue: #d9edfc;
$progress-blue: #2b84c5;

.prompt-bar-container {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-75);
  background: $background-blue;
  color: $progress-text-blue;
  min-height: 4rem;

  .content-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .icon {
    flex-shrink: 0;
    align-self: center;
    width: 20px;
    height: 20px;
    margin-right: var(--spacing-100);
    fill: $progress-text-blue;
  }

  .text-container {
    display: flex;
    flex-direction: column;
    margin-right: var(--spacing-100);

    .text-title {
      font-weight: 700;
    }
  }

  .progress-bar {
    position: absolute;
    bottom: 0;
    width: 0%;
    height: var(--spacing-25);
    left: 0;
    background: $progress-blue;
    animation: progress-bar 20s linear;
  }

  .close-button {
    position: absolute;
    right: var(--spacing-75);
    top: var(--spacing-75);
  }
}

@keyframes progress-bar {
  0% {
    width: 100%;
  }

  100% {
    width: 0%;
  }
}

@media only screen and (max-width: $sm) {
  .prompt-bar-container {
    flex-direction: column;
    min-height: $mobile-height;
    align-items: flex-start;

    .icon {
      margin-right: var(--spacing-75);
    }

    .close-button {
      right: var(--spacing-25);
      top: var(--spacing-25);
    }

    .button-container {
      flex-direction: column;
      width: 100%;
      margin-top: var(--spacing-100);

      :deep(button) {
        width: 100%;
      }
    }
  }
}
</style>
